import { NgModule } from '@angular/core';
import { ManagersAgreementsComponent } from '../pages/managers-agreements.component';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { ApiCore, ApiPoseedores, ApiDocum,ApiAcuerdosGestores } from 'api-rest';
import { ManagersAgreementsSearchComponent } from '../pages/managers-agreements-search/managers-agreements-search.component';
import { EmpusaSpinnerComponent } from '@empusa/empusa-core';
import { GeTableComponent } from '../share/components/ge-table.component';
import { MaterialModule } from './material.module';
import { CustomDatePickerModule } from './custom-date-picker.module';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { GetAttributePipe } from '../share/components/pipe/get-attribute.pipe';
import { GeSelectPaginationComponent } from '../share/components/ge-select-pagination/ge-select-pagination.component';
import { DecimalNumberDirective } from '../share/components/utils/DecimalNumberDirective.directive';
import { TwoDigitDecimalNumberDirective } from '../share/components/utils/TwoDigitDecimalNumberDirective.directive';
import { ManagersAgreementsContributionsDisComponent } from '../pages/managers-agreements-contributions-dis/managers-agreements-contributions-dis.component';
import { ManagersAgreementsContributionsDisDialogComponent } from '../pages/managers-agreements-contributions-dis-dialog/managers-agreements-contributions-dis-dialog.component';
import { ManagersAgreementsManagerSelectionDialogComponent } from '../pages/managers-agreements-manager-selection-dialog/managers-agreements-manager-selection-dialog.component';
import { ManagersAgreementsSelfInvoicesSearchComponent } from '../pages/managers-agreements-self-invoices-search/managers-agreements-self-invoices-search.component';
import { ManagersAgreementsInvoiceNewDocumentDialogComponent } from '../pages/managers-agreements-invoice-document-dialog/managers-agreements-invoice-document-dialog.component';
import { ManagersAgreementsContributionsDisPreviewDialogComponent } from '../pages/managers-agreements-contributions-dis-dialog/managers-agreements-contributions-dis-preview-dialog.component';
import { ManagersAgreementsContributionsDisDeclineDialogComponent } from '../pages/managers-agreements-contributions-dis-cancel-dialog/managers-agreements-contributions-dis-cancel-dialog.component';
import { ManagersAgreementsInvoiceRejectDialogComponent } from '../pages/managers-agreements-invoice-reject-dialog/managers-agreements-invoice-reject-dialog.component';
import { ManagersAgreementsContributionsDisImageDialogComponent } from '../pages/managers-agreements-contributions-dis-image-dialog/managers-agreements-contributions-dis-image-dialog.component';
import { IndirectAgreementSearchComponent } from '../pages/indirect-agreement-search/indirect-agreement-search.component';
import { IndirectAgreementDialogComponent } from '../pages/indirect-agreement-dialog/indirect-agreement-dialog.component';
import { IndirectAgreementDetailComponent } from '../pages/indirect-agreement-detail/indirect-agreement-detail.component';
import { DetailAdressComponent } from '../pages/detail-adress/detail-adress.component';
import { AdressDialogComponent } from '../pages/adress-dialog/adress-dialog.component';
import { ManagersContactDialogComponent } from '../pages/contact-dialog/contact-dialog.component';
import { DetailContactDataComponent } from '../pages/detail-contact-data/detail-contact-data.component';
import { DetailAuthorizedWasteComponent } from '../pages/detail-authorized-waste/detail-authorized-waste.component';
import { DetailGeographicScopeComponent } from '../pages/detail-geographic-scope/detail-geographic-scope.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { GeographicScopeDialogComponent } from '../pages/geographic-scope-dialog/geographic-scope-dialog.component';
import { DetailDocumentsComponent } from '../pages/detail-documents/detail-documents.component';
import { DocumentsDialogComponent } from '../pages/documents-dialog/documents-dialog.component';
import { IndirectManagersAgreementsComponent } from '../pages/indirect-managers-agreements/indirect-managers-agreements.component';
import { ManagersAgreementsAddModalComponent } from '../pages/managers-agreements-add-modal/managers-agreements-add-modal.component';
import { ManagersAgreementsHoldersComponent } from '../pages/managers-agreements-holders/managers-agreements-holders.component';
import { ManagersAgreementsHoldersModalComponent } from '../pages/managers-agreements-holders-modal/managers-agreements-holders-modal.component';
import { ManagersAgreementsHoldersRelationModalComponent } from '../pages/managers-agreements-holders-relation-modal/managers-agreements-holders-relation-modal.component';
import { IndirectAgreementAddManagerModalComponent } from '../pages/indirect-agreement-add-manager-modal/indirect-agreement-add-manager-modal.component';
import { IndirectAgreementUploadAgreementModalComponent } from '../pages/indirect-agreement-upload-agreement-modal/indirect-agreement-upload-agreement-modal.component';
import { IndirectAgreementCodLerModalComponent } from '../pages/indirect-agreement-cod-ler-modal/indirect-agreement-cod-ler-modal.component';
import { ManagersAgreementsInvoicesDetailDialogComponent } from '../pages/managers-agreements-invoices-detail-dialog/managers-agreements-invoices-detail-dialog.component';
import { ManagersAgreementsInvoiceAccountingDialogComponent } from '../pages/managers-agreements-invoice-accounting-dialog/managers-agreements-invoice-accounting-dialog.component';
import { ManagersAgreementsSelfInvoicesCancelRevisionDialogComponent } from '../pages/managers-agreements-self-invoices-cancel-revision-dialog/managers-agreements-self-invoices-cancel-revision-dialog.component';
import { IndirectAgreementContributionsDisUploadDialogComponent } from '../pages/indirect-agreement-contributions-dis-upload-dialog/indirect-agreement-contributions-dis-upload-dialog.component';
import { ManagersAgreementsGenerateConsentModalComponent } from '../pages/managers-agreements-generate-consent-modal/managers-agreements-generate-consent-modal.component';
import { ManagersAgreementsConsentHoldersModalComponent } from '../pages/managers-agreements-consent-holders-modal/managers-agreements-consent-holders-modal.component';

export const CoreConfigFactory = () =>
  new ApiCore.Configuration(<ApiCore.ConfigurationParameters>{});

export const AcuerdosConfigFactory = () =>
  new ApiAcuerdosGestores.Configuration(<ApiAcuerdosGestores.ConfigurationParameters>{});

export const CoreBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE CORE ' + environment.urlBackCore);
  const basePath = environment.urlBackCore;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};
export const AcuerdosConGestoresBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE ACUERDOS CON GESTORES ' + environment.urlBackAcuerdosConGestores);
  const basePath = environment.urlBackAcuerdosConGestores;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};
export const DocumBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE DOCUM ' + environment.urlBackDocum);
  const basePath = environment.urlBackDocum;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};

export const DocumConfigFactory = () =>
  new ApiDocum.Configuration(<ApiDocum.ConfigurationParameters>{});

export const explorerRoutes = [
  {
    path: '',
    component: ManagersAgreementsComponent,
    children: [
      { path: 'search', component: ManagersAgreementsSearchComponent },
      { path: 'contributions-dis-search', component: ManagersAgreementsContributionsDisComponent },
      { path: 'invoices-search', component: ManagersAgreementsSelfInvoicesSearchComponent },
      { path: 'indirect-agreement-search', component: IndirectAgreementSearchComponent },
      { path: 'indirect-agreement-detail', component: IndirectAgreementDetailComponent },
    ],
  },
];

@NgModule({
  declarations: [
    ManagersAgreementsComponent,
    ManagersAgreementsSearchComponent,
    GeTableComponent,
    GetAttributePipe,
    GeSelectPaginationComponent,
    ManagersAgreementsContributionsDisComponent,
    ManagersAgreementsContributionsDisDialogComponent,
    ManagersAgreementsManagerSelectionDialogComponent,
    ManagersAgreementsSelfInvoicesSearchComponent,
    ManagersAgreementsInvoiceNewDocumentDialogComponent,
    ManagersAgreementsContributionsDisDeclineDialogComponent,
    DecimalNumberDirective,
    TwoDigitDecimalNumberDirective,
    ManagersAgreementsInvoiceRejectDialogComponent,
    ManagersAgreementsContributionsDisImageDialogComponent,
    IndirectAgreementSearchComponent,
    IndirectAgreementDialogComponent,
    IndirectAgreementDetailComponent,
    DetailAdressComponent,
    AdressDialogComponent,
    ManagersContactDialogComponent,
    DetailContactDataComponent,
    DetailAuthorizedWasteComponent,
    DetailGeographicScopeComponent,
    GeographicScopeDialogComponent,
    DetailDocumentsComponent,
    DocumentsDialogComponent,
    IndirectManagersAgreementsComponent,
    ManagersAgreementsAddModalComponent,
    ManagersAgreementsHoldersComponent,
    ManagersAgreementsHoldersModalComponent,
    ManagersAgreementsHoldersRelationModalComponent,
    ManagersAgreementsGenerateConsentModalComponent,
    ManagersAgreementsConsentHoldersModalComponent,
    IndirectAgreementAddManagerModalComponent,
    IndirectAgreementUploadAgreementModalComponent,
    IndirectAgreementCodLerModalComponent,
    ManagersAgreementsContributionsDisPreviewDialogComponent,
    ManagersAgreementsInvoicesDetailDialogComponent,
    ManagersAgreementsInvoiceAccountingDialogComponent,
    ManagersAgreementsSelfInvoicesCancelRevisionDialogComponent,
    IndirectAgreementContributionsDisUploadDialogComponent
  ],
  imports: [
    NgbTooltipModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgSelectModule,
    CommonModule,
    ApiDocum.ApiModule.forRoot(DocumConfigFactory),
    RouterModule.forChild(explorerRoutes),
    MaterialModule,
    EmpusaSpinnerComponent,
    CustomDatePickerModule,
    NgxMatSelectSearchModule,
  
  ],
  exports: [ManagersAgreementsComponent],
  providers:[
    DatePipe,
    ...ApiAcuerdosGestores.APIS,
    {
      provide: ApiPoseedores.BASE_PATH,
      useFactory: AcuerdosConGestoresBasePathFactory,
      deps: ['environment'],
    },
    {
      provide: ApiDocum.BASE_PATH,
      useFactory: DocumBasePathFactory,
      deps: ['environment'],
    },
        {
      provide: ApiAcuerdosGestores.BASE_PATH,
      useFactory: AcuerdosConGestoresBasePathFactory,
      deps: ['environment'],
    },
  ]
})
export class ManagersAgreementsHomeModule {
  constructor() {
   let compilationVersion = ""
    console.log('managers-agreements version: ' + compilationVersion);
  }
}
